import React from 'react';
import Select from '../../../components/ui/Select';

const FilterControls = ({ filters, onFilterChange }) => {
  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'draft', label: 'Draft' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'pending', label: 'Pending Review' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
  ];

  const ageCategoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'Boys U14', label: 'Boys U14' },
    { value: 'Girls U15', label: 'Girls U15' },
    { value: 'Boys U16', label: 'Boys U16' },
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'completion', label: 'Completion %' },
  ];

  return (
    <div className="card">
      <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
        <span>Filter Registrations</span>
      </h3>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />
        <Select
          label="Age Category"
          options={ageCategoryOptions}
          value={filters?.ageCategory}
          onChange={(value) => onFilterChange('ageCategory', value)}
        />
        <Select
          label="Sort By"
          options={sortOptions}
          value={filters?.sortBy}
          onChange={(value) => onFilterChange('sortBy', value)}
        />
      </div>
    </div>
  );
};

export default FilterControls;